<!--
订单模块商品组件

<template>
  <div style="padding: 15px;">
    <OrderProduct
      :image="product.image"
      :product-name="product.productName"
      :color="product.color"
      :size="product.size"
      :price="product.price"
      :quantity="product.quantity"
    />
  </div>
</template>

<script>
import OrderProduct from '@/components/mobile/OrderProduct.vue'
export default {
  components: { OrderProduct },
  data() {
    return {
      product: {
        image: 'https://img.kakaclo.com/image%2FFSZW03960%2FFSZW03960_Y_S_NUB%2F34effc7f3599a84e9f7ee0a18111f068.jpg',
        productName: `Women's Floral Bandeau Boho Maxi Dress`,
        color: 'blue',
        size: 'L',
        price: 35,
        quantity: 2
      }
    }
  }
}
</script>
 -->
<template>
  <div class="mobile-order-product f" @click="viewDetail">
    <div class="mobile-order-product-image">
      <img :src="image">
      <div v-if="product.productType === 3" class="tag">POD</div>
    </div>
    <div class="mobile-order-product-info">
      <div class="f-b">
        <p :class="{ellipsis: isPC}">{{productName}}</p>
        <i class="icon-pinpaitemai-tianchong iconfont" style="color: #99c41c;width: 20px;" v-if="!isPC && product.attachmentSkuVos && product.attachmentSkuVos.length"></i>
      </div>

      <p class="gray" style="margin-bottom: 4px">{{color}}, {{size}}</p>
      <div class="f-b">
        <div>
          <p :class="{red: finalAmount !== price}" style="font-size: 14px; color: #7B7B7B">${{ finalAmount }}</p>
          <p class="gray" v-if="finalAmount !== price" style="text-decoration: line-through;font-size: 12px;font-weight: 400">${{ price }}</p>
        </div>
        <div class="f--c">
          <div style="margin-right: .3rem;font-size: .2rem;font-weight: 400" class="f">X {{quantity}}</div>
          <div class="finalAmount">$ {{(finalAmount * quantity).toFixed(2)}}</div>
        </div>
      </div>
      <p class="refundStatus f--c" v-if="product.refundStatus && product.refundStatus !== 'NULL'">{{ product.refundStatus | refundText }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: ''
    },
    productName: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    price: {
      type: [String, Number],
      default: ''
    },
    quantity: {
      type: [String, Number],
      default: ''
    },
    finalAmount: {
      type: [String, Number],
      default: ''
    },
    product: {
      type: Object,
      default: () => ({})
    }
  },
  filters: {
    refundText(value) {
      if (value === 'refunding') return 'Refunding'
      if (value === 'partial_refund') return 'Partial Refund'
      if (value === 'refunded') return 'Refunded'
      return ''
    }
  },
  methods: {
    viewDetail() {
      this.$emit('viewDetail')
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-order-product{
  width: 100%;
  position: relative;
  .mobile-order-product-image{
    width: 1.6rem;
    height: 1.6rem;
    flex-shrink: 0;
    border-radius: .16rem;
    margin-right: .24rem;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .tag {
      position: absolute;
      bottom: 8px;
      background-color: #F7FCEB;
      width: 100%;
      height: 16px;
      font-size: 12px;
      line-height: 16px;
      text-align:center;
      color: #9AC331;
    }
  }
  .mobile-order-product-info{
    width: calc(100% - 1.84rem);
    font-size: .28rem;
    line-height: .38rem;
    .finalAmount{
      font-weight: 500;
      font-size: .32rem;
    }
    .red{
      color: #A6100C !important;
    }
  }
  .mobile-order-product-total-price{
    position: absolute;
    bottom: 0;
    right: 0;
    font-weight: 600;
    font-size: .32rem;
  }
}
.gray{
  color: #7B7B7B;
}
.refundStatus{
  color: #AB1E1A;
  margin-top: 4px;
}
.refundStatus::before{
  content: '';
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #AB1E1A;
  margin-right: 8px;
}
</style>
